export const REPORT_TEMPLATES_STORAGE_KEY = "report_templates_v1";
export const REPORT_TEMPLATE_PENDING_ID_KEY = "report_template_pending_id";

export const REPORT_TAB_SUBSCRIPTION = "subscription";
export const REPORT_TAB_VERSION = "versionSoft";
export const REPORT_TAB_SERIALISATION = "serialisation";

export const REPORT_TEMPLATE_APPLY_EVENT = "report-template-apply";
export const REPORT_TEMPLATES_CHANGED_EVENT = "report-templates-changed";

function safeParseJson(raw, fallback) {
  if (!raw) {
    return fallback;
  }
  try {
    return JSON.parse(raw);
  } catch {
    return fallback;
  }
}

export function readReportTemplates() {
  const parsed = safeParseJson(
    localStorage.getItem(REPORT_TEMPLATES_STORAGE_KEY),
    [],
  );
  if (!Array.isArray(parsed)) {
    return [];
  }
  return parsed.filter(
    (t) =>
      t &&
      typeof t.id === "string" &&
      typeof t.name === "string" &&
      typeof t.tab === "string" &&
      t.fields &&
      typeof t.fields === "object",
  );
}

export function writeReportTemplates(templates) {
  try {
    localStorage.setItem(
      REPORT_TEMPLATES_STORAGE_KEY,
      JSON.stringify(templates),
    );
    window.dispatchEvent(new Event(REPORT_TEMPLATES_CHANGED_EVENT));
  } catch (e) {
    console.error("reportTemplatesStorage: failed to save", e);
  }
}

export function createReportTemplateId() {
  if (typeof crypto !== "undefined" && crypto.randomUUID) {
    return crypto.randomUUID();
  }
  return `report-tpl-${Date.now()}-${Math.random().toString(36).slice(2, 9)}`;
}

export function findTemplateById(id) {
  if (!id) {
    return null;
  }
  return readReportTemplates().find((t) => t.id === id) ?? null;
}

export function addReportTemplate({ name, tab, fields }) {
  const trimmedName = String(name ?? "").trim();
  if (!trimmedName) {
    return null;
  }
  const template = {
    id: createReportTemplateId(),
    name: trimmedName,
    tab,
    fields,
  };
  const next = [...readReportTemplates(), template];
  writeReportTemplates(next);
  return template;
}

export function removeReportTemplate(id) {
  if (!id) {
    return false;
  }
  const next = readReportTemplates().filter((t) => t.id !== id);
  if (next.length === readReportTemplates().length) {
    return false;
  }
  writeReportTemplates(next);
  return true;
}

export function peekPendingTemplateId() {
  return sessionStorage.getItem(REPORT_TEMPLATE_PENDING_ID_KEY);
}

export function setPendingTemplateId(id) {
  try {
    sessionStorage.setItem(REPORT_TEMPLATE_PENDING_ID_KEY, id);
  } catch (e) {
    console.error("reportTemplatesStorage: failed to set pending id", e);
  }
}

export function clearPendingTemplateId() {
  try {
    sessionStorage.removeItem(REPORT_TEMPLATE_PENDING_ID_KEY);
  } catch {
    /* ignore */
  }
}

export function takePendingTemplateId() {
  const id = peekPendingTemplateId();
  clearPendingTemplateId();
  return id;
}

export function findPendingTemplate() {
  const id = peekPendingTemplateId();
  if (!id) {
    return null;
  }
  return findTemplateById(id);
}
